import { CommonModule, UpperCasePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ScheduleEvent } from '../../models/ScheduleModels';

export interface GameEventDetailsDialogResult {
  action?: 'delete' | 'viewGame';
  eventId?: string;
  gameId?: string;
}

@Component({
  selector: 'app-game-event-details-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, TranslatePipe, UpperCasePipe],
  templateUrl: './game-event-details-dialog.component.html',
  styleUrl: './game-event-details-dialog.component.css'
})
export class GameEventDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<GameEventDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScheduleEvent,
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  toDisplayDate(value: Date | string | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }

    const raw = value.toString().trim();
    if (!raw) {
      return null;
    }

    // Guard against malformed backend values like "...ZZ" and add UTC marker if missing.
    const normalized = raw.endsWith('ZZ')
      ? `${raw.slice(0, -1)}`
      : (!raw.endsWith('Z') && !raw.includes('+') ? `${raw}Z` : raw);

    const parsed = new Date(normalized);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  onDelete(): void {
    this.dialogRef.close({ action: 'delete', eventId: this.data.EventId } as GameEventDetailsDialogResult);
  }

  onViewGame(): void {
    this.dialogRef.close({ action: 'viewGame', gameId: this.data.GameId } as GameEventDetailsDialogResult);
  }
}
